// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.use-error-dialog-module__errorDialogOverlay___kHxn8 {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.use-error-dialog-module__errorDialog___yVxnA {
    background: white;
    border-radius: 8px;
    padding: 20px;
    max-width: 400px;
    width: 90%;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.use-error-dialog-module__errorDialogHeader___S8kXX {
    margin-bottom: 16px;
}

.use-error-dialog-module__errorDialogTitle___o9Byz {
    margin: 0;
    color: #dc2626;
    font-size: 1.25rem;
}

.use-error-dialog-module__errorDialogContent___Qqx4b {
    margin-bottom: 20px;
}

.use-error-dialog-module__errorDialogMessage___h_HZA {
    margin: 0;
    color: #4b5563;
}

.use-error-dialog-module__errorDialogFooter___l7afX {
    display: flex;
    justify-content: flex-end;
}

.use-error-dialog-module__errorDialogButton___wMV28 {
    padding: 8px 16px;
    background-color: #dc2626;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 0.875rem;
}

    .use-error-dialog-module__errorDialogButton___wMV28:hover {
        background-color: #b91c1c;
    }
`, "",{"version":3,"sources":["webpack://./app/components/ProofOfDeliveryLayout/Contexts/error-dialog/use-error-dialog.module.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,UAAU;IACV,yCAAyC;AAC7C;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,mBAAmB;AACvB;;IAEI;QACI,yBAAyB;IAC7B","sourcesContent":[".errorDialogOverlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.5);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n}\n\n.errorDialog {\n    background: white;\n    border-radius: 8px;\n    padding: 20px;\n    max-width: 400px;\n    width: 90%;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n}\n\n.errorDialogHeader {\n    margin-bottom: 16px;\n}\n\n.errorDialogTitle {\n    margin: 0;\n    color: #dc2626;\n    font-size: 1.25rem;\n}\n\n.errorDialogContent {\n    margin-bottom: 20px;\n}\n\n.errorDialogMessage {\n    margin: 0;\n    color: #4b5563;\n}\n\n.errorDialogFooter {\n    display: flex;\n    justify-content: flex-end;\n}\n\n.errorDialogButton {\n    padding: 8px 16px;\n    background-color: #dc2626;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 0.875rem;\n}\n\n    .errorDialogButton:hover {\n        background-color: #b91c1c;\n    }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorDialogOverlay": `use-error-dialog-module__errorDialogOverlay___kHxn8`,
	"errorDialog": `use-error-dialog-module__errorDialog___yVxnA`,
	"errorDialogHeader": `use-error-dialog-module__errorDialogHeader___S8kXX`,
	"errorDialogTitle": `use-error-dialog-module__errorDialogTitle___o9Byz`,
	"errorDialogContent": `use-error-dialog-module__errorDialogContent___Qqx4b`,
	"errorDialogMessage": `use-error-dialog-module__errorDialogMessage___h_HZA`,
	"errorDialogFooter": `use-error-dialog-module__errorDialogFooter___l7afX`,
	"errorDialogButton": `use-error-dialog-module__errorDialogButton___wMV28`
};
export default ___CSS_LOADER_EXPORT___;
